module.exports = __webpack_public_path__ + "static/media/O-1-Confirm-Transformer-Power-Rating.88012ba8.svg";